import { sellerQueries } from '@/api';

import { useQuery } from '@tanstack/react-query';
import { useLocalStorage } from 'usehooks-ts';
import { EmailDialog } from './email-dialog';
import { NicknameDialog } from './nickname-dialog';
import { PasswordDialog } from './password-dialog';
import { PhoneDialog } from './phone-dialog';
import { ProfileImage } from './profile-image';

export const InfoContainer = () => {
  const [localStorageCplatToken] = useLocalStorage('cplatToken', '');
  const getUserInfoQuery = useQuery(sellerQueries.getInfo({ cplatToken: localStorageCplatToken }));

  const userInfoData = getUserInfoQuery.data?.data?.[0];

  return (
    <div className="flex flex-col items-center gap-5 rounded-[16px] bg-white p-5">
      <ProfileImage defaultImageUrl={userInfoData?.sellerImageUrl} />
      <div className="w-[400px] space-y-3">
        <NicknameDialog defaultValue={userInfoData?.name} />
        <Divider />
        <PhoneDialog defaultValue={userInfoData?.phoneNumber} />
        <Divider />
        <EmailDialog defaultValue={userInfoData?.accountEmail} />
        <Divider />
        <PasswordDialog />
      </div>
    </div>
  );
};

const Divider = () => {
  return <div className="h-px w-full bg-gr-50" />;
};
